import ExportStatisticShutter from './component'

export default ExportStatisticShutter
